import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { IpPublicService } from '../../../../services/ip-public.service';
import { ModalService } from '../../../../services/modal.service';
import { AlertService } from '../../../../services/alert.service';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { AccionService } from 'src/app/modulos/elementos-plan/services/accion.service';
import { EquipoGerencialService } from '../../services/equipo.gerencial.service';
import { RiesgosService } from 'src/app/modulos/elementos-plan/services/riesgos.service';
import { ProyectoService } from 'src/app/modulos/elementos-plan/services/proyecto.service';
import { HitoService } from 'src/app/modulos/elementos-plan/services/hito.service';
import { AmbienteService } from './../../../catalogos-admin/services/ambiente.service';
import { ProcesoService } from 'src/app/modulos/elementos-plan/services/proceso.service';
import { DesempenioProcesoService } from 'src/app/modulos/elementos-plan/services/desempenio-proceso.service';
import { ConfiguracionIndicadoresService } from 'src/app/modulos/elementos-plan/services/configuracion-indicadores.service';
import { ConfigPeriodosService } from '../../services/config-periodos.service';

@Component({
  selector: 'app-config-periodos',
  templateUrl: './config-periodos.component.html',
  styleUrls: ['./config-periodos.component.css']
})
export class ConfigPeriodosComponent implements OnInit, OnDestroy {

  breadCrumbItems = [{ label: 'Administración Procesos' }, { label: 'Catálogos' }, { label: 'Común', active: true }];

  public mostrarModal: boolean = false;
  public dataViewTable!: any;
  public dataAll!: any;
  public submitted = false;
  public formComun!: UntypedFormGroup;
  public formSelectCatalogo!: UntypedFormGroup;
  selectedOptionRecursivo: any = null;
  selectedOptionState: number = 0;
  selectedSprComun: number = 0;
  filtroPost = ''; //para la clase filtro
  fathers: any = [];
  buffer!: any;
  currentUser!: any

  public selectItems: any[] = [];
  public ipAddress!: string;
  public nombrePadre: string = null;//para validacion de catalogo que salga el nombre
  public nameModal: string = 'modalNewEdit'
  private idDeleteRegister: number = 0;
  public selectMain: any[] = [];

  nameApp = 'CATÁLOGO COMÚN';

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  isDtInitialized: boolean = false;


  constructor(
    private fb: FormBuilder,
    private ip: IpPublicService,
    private configPeriodosService: ConfigPeriodosService,
    private alert: AlertService,
    private accionService: AccionService,
    private equipoGerencialService: EquipoGerencialService,
    private riesgoService: RiesgosService,
    private proyectoService: ProyectoService,
    private hitoService: HitoService,
    private ambienteService: AmbienteService,
    private configIndicadorService: ConfiguracionIndicadoresService,
    private procesoService: ProcesoService,
    private desempenioService: DesempenioProcesoService,
    public modal: ModalService
  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
  }



  get comunForm() {
    return this.formComun.controls;
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }
  ngOnInit() {
    this.getIpPublic();
    this.initApp();

  }


  initApp() {
    this.listDataApp(0);
    this.setDataTable();
    this.setForm();
  }

  listDataApp(idDependiente: number = 0) {
    if (idDependiente == 0) {
      this.configPeriodosService.list().subscribe(resp => {
        this.dataAll = resp;
        this.getDataDependiente(this.selectedOptionRecursivo)
        //this.setSelectMain();
        this.setSelectCatalogoPadre(" ");
        this.reDrawDataTable();

      });
    } else {
      //this.setSelectMain();
      this.getDataDependiente(idDependiente);
      this.reDrawDataTable();
    }

    return true;
  }



  setSelectMain() {
    this.selectMain = [];

    this.selectMain.push({ idSprComun: " ", nombre: "Seleccione..." });
    for (let i = 0; i < this.fathers.length; i++) {
        this.selectMain.push({ idSprComun: this.fathers[i].idSprComun, nombre: this.fathers[i].nombre });
    }
    this.selectItems = [
      { value: " ", label: 'Seleccione' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
  }


  setForm() {
    this.formComun = this.fb.group({
      idSprComun: [],
      nombrePadre: [],
      spr_idSprComun: ['', []],
      nombre: ['', [Validators.required]],
      descripcion: [''],
      estado: ['', [Validators.required]],
    });

    this.formSelectCatalogo = this.fb.group({
      spr_idSprComun: ['', []],
    });
  }

  setSelectCatalogoPadre(idSelect: string = " ") {
    this.formSelectCatalogo = this.fb.group({
      spr_idSprComun: [idSelect, []],
    });

    this.formComun = this.fb.group({
      idSprComun: [],
      spr_idSprComun: [idSelect, []],
      nombre: ['', [Validators.required]],
      nombrePadre:[],
      descripcion: [''],
      estado: [idSelect, [Validators.required]],
    });
  }


  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }




  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  cargarCatalogoDependiente(a: any) {
    this.selectedOptionRecursivo = a.value
    this.nombrePadre = a[a['options'].selectedIndex].text
    if (this.selectedOptionRecursivo != 0) {
       this.getDataDependiente(this.selectedOptionRecursivo)

       }else{;
        this.dataViewTable = this.fathers;
       }
  }


  getDataDependiente(spr_idSprComun: any = null) {
    this.configPeriodosService.list().subscribe(resp => {

      
      this.dataAll = resp;
      let stateOptionTipo = false;
      let father = "N/A";
      let dataAllProcesar = this.dataAll;
      let dependientes: any = [];
      resp.forEach((row: any) => {
        if (!stateOptionTipo && spr_idSprComun != null) {
          father = (row.idSprComun == spr_idSprComun) ? row.nombre : "";
          if (father != "") { stateOptionTipo = true; }
        }
        if (row.spr_idSprComun == spr_idSprComun) {

          
          dependientes.push(
            {
              idSprComun: row.idSprComun,
              nombre: row.nombre,
              descripcion: row.descripcion,
              spr_idSprComun: row.spr_idSprComun,
              estado: row.estado,
              tipo: father,
            });
        }
      });

      if (spr_idSprComun == null || spr_idSprComun == 0) {
        this.dataViewTable = dependientes
        this.fathers = dependientes
        this.setSelectMain();
      } else {
        this.dataViewTable = dependientes
        ///this.reDrawDataTable();
      }
    });
  }

  // Modal Crear/editar
  closeModal() {
    this.onResetForm();
    return this.modal.close();
  }

  onSubmit() {
    this.submitted = true;
    this.formComun.value.usuario = this.currentUser.idSprUsuario;
    this.formComun.value.ip = this.ipAddress;
    this.formComun.value.nombre = this.formComun.value.nombre.toUpperCase();
    this.formComun.value.nombre.trim();
    this.formComun.value.delLog = "N";
    //if (!this.formComun.invalid) {
    this.selectedOptionRecursivo = this.formComun.value.spr_idSprComun;
    //Realizar el posteo
    if (this.formComun.value.idSprComun == null) {
      if (this.listCatalogoComunExiste(this.formComun.value.nombre))//para que no repita el mismo nombre
        this.configPeriodosService.create(this.formComun.value)
          .subscribe(resp => {
            this.listDataApp(this.selectedOptionRecursivo);
            this.setSelectCatalogoPadre(this.selectedOptionRecursivo);
            this.alert.createOk()
            this.closeModal();
          }, (err) => {
            this.alert.createError();
          });
    } else {
      this.configPeriodosService.update(this.formComun.value)
        .subscribe(resp => {
          this.setSelectCatalogoPadre(this.selectedOptionRecursivo);
          this.listDataApp(this.selectedOptionRecursivo);
          this.closeModal();
          this.alert.updateOk();
        }, (err) => {
          this.alert.updateError();
        });
    }
  }

  edit(obj: any) {
    this.openModal();
    this.formComun.patchValue({
      idSprComun: obj.idSprComun,
      spr_idSprComun: obj.spr_idSprComun,
      nombre: obj.nombre,
      descripcion: obj.descripcion,
      estado: obj.estado
    });
  }



  delete2(id: number) {



    this.configPeriodosService.delete(
      {
        "idSprComun": id,
        "usuario": this.currentUser.idSprUsuario,
        "delLog": "S",
        "ip": this.ipAddress
      })
      .subscribe(resp => {
        this.listDataApp();
        this.getDataDependiente(this.selectedOptionRecursivo);
        this.modal.closeId('delete-comun')
        this.alert.deleteOk();
      }, (err) => {
        this.alert.deleteError();
      });

  }



  listCatalogoComunExiste(nombre: any) { // para que no se repita los nombres
    for (let elemento of this.dataAll) {
      if (elemento.nombre == nombre) {
        this.alert.RepetirNombre()
        return false
      }
    }
    return true


  }
  getParent(id: number) { // validacion para que no se pueda eliminar un padre con hijos

    for (let elemento of this.dataAll) {

      if (elemento.spr_idSprComun == id) {
       this.alert.EliminarRegistroCatalogo()
       this.modal.closeId('delete-comun')
       return false
      }
   }
    return true
  }

  delete(idRegister: number) {
    this.modal.open('delete-comun');

    this.idDeleteRegister = idRegister;
  }

///////////////////////////Verificación de eliminación de la tabla Accion-tipo de accion/////////////////////
  verifyAccion(){
    return this.accionService.list(`?idSprTipoAccion=${this.idDeleteRegister}&delLog=N`).toPromise();
} 
///////////////////////////Verificación de eliminación de la tabla Equipo gerencial-tipo de participante/////////////////////
 verifyEquipoGerencial(){
  return this.equipoGerencialService.list(`?idSprTipoParticipante=${this.idDeleteRegister}&delLog=N`).toPromise();
} 
 ///////////////////////////Verificación de eliminación de la tabla Riesgo-estructtura edr/////////////////////
 verifyRiesgo(){
  return this.riesgoService.list(`?idSprEstructuraEdr=${this.idDeleteRegister}&delLog=N`).toPromise();
} 
///////////////////////////Verificación de eliminación de la tabla proyecto-tipo de cliente/////////////////////
verifyTipoCliente(){
  return this.proyectoService.list(`?idSprTipoCliente=${this.idDeleteRegister}&delLog=N`).toPromise();
}
///////////////////////////Verificación de eliminación de la tabla proyecto-tipo de proyecto/////////////////////
verifyTipoProyecto(){
  return this.proyectoService.list(`?idSprTipoProyecto=${this.idDeleteRegister}&delLog=N`).toPromise();
}
///////////////////////////Verificación de eliminación de la tabla proyecto-viabilidada tecnica/////////////////////
verifyViabilidadTecnica(){
  return this.proyectoService.list(`?idSprViabilidadTecnica=${this.idDeleteRegister}&delLog=N`).toPromise();
}
///////////////////////////Verificación de eliminación de la tabla hito-categoria de hito/////////////////////
verifyHito(){
  return this.hitoService.list(`?idSprCategoriaHito=${this.idDeleteRegister}&delLog=N`).toPromise();
}
///////////////////////////Verificación de eliminación de la tabla ambiente- nivel/////////////////////
verifyAmbiente(){
  return this.ambienteService.list(`?idSprNivel=${this.idDeleteRegister}&delLog=N`).toPromise();
}
///////////////////////////Verificación de eliminación de la tabla proceso-mejoras/////////////////////
verifyMejoras(){
  return this.procesoService.list(`?idSprMejoras=${this.idDeleteRegister}&delLog=N`).toPromise();
}
///////////////////////////Verificación de eliminación de la tabla proceso-tipo de clentel/////////////////////
verifyProceTipoCliente(){
  return this.procesoService.list(`?idSprTipoCliente=${this.idDeleteRegister}&delLog=N`).toPromise();
}
///////////////////////////Verificación de eliminación de la tabla desempeño de preoceso-caracteristica/////////////////////
verifyCaracteristicasDesempenio(){
  return this.desempenioService.list(`?idSprCaracteristica=${this.idDeleteRegister}&delLog=N`).toPromise();
}
///////////////////////////Verificación de eliminación de la tabla desempeño de preoceso-desempenio/////////////////////
verifyDesempenio(){
  return this.desempenioService.list(`?idSprDesempenio=${this.idDeleteRegister}&delLog=N`).toPromise();
}
///////////////////////////Verificación de eliminación de la tabla desempeño de preoceso-importancia/////////////////////
verifyImportanciaDesempenio(){
  return this.desempenioService.list(`?idSprImportancia=${this.idDeleteRegister}&delLog=N`).toPromise();
}
///////////////////////////Verificación de eliminación de la tabla configIndicador-comportamiento/////////////////////
verifyComportamientoIndicador(){
  return this.configIndicadorService.list(`?idSprComportamiento=${this.idDeleteRegister}&delLog=N`).toPromise();
}
///////////////////////////Verificación de eliminación de la tabla configIndicador-frecuencia/////////////////////
verifyFrecuenciaIndicador(){
  return this.configIndicadorService.list(`?idSprFrecuencia=${this.idDeleteRegister}&delLog=N`).toPromise();
}
///////////////////////////Verificación de eliminación de la tabla configIndicador-expresion/////////////////////
verifyExpresionIndicador(){
  return this.configIndicadorService.list(`?idSprExpresion=${this.idDeleteRegister}&delLog=N`).toPromise();
}



  async confirmDelete() {

    let confirmDelete = true;
    let dataVerifyRelacion: any = [];
   
     //##############  verificacion1 si existe datos relacionado ########################
    dataVerifyRelacion =  await this.verifyAccion();
     (dataVerifyRelacion.length > 0 ) ? confirmDelete = false : ""; 
    //
    //##############  verificacion1 si existe datos relacionado ########################
      dataVerifyRelacion =  await this.verifyEquipoGerencial();
     (dataVerifyRelacion.length > 0 ) ? confirmDelete = false : ""; 
    //
    
   //##############  verificacion1 si existe datos relacionado ########################
      dataVerifyRelacion =  await this.verifyRiesgo();
     (dataVerifyRelacion.length > 0 ) ? confirmDelete = false : ""; 
    //
    //##############  verificacion1 si existe datos relacionado ########################
    dataVerifyRelacion =  await this.verifyTipoCliente();
     (dataVerifyRelacion.length > 0 ) ? confirmDelete = false : ""; 
    //
      //##############  verificacion1 si existe datos relacionado ########################
     dataVerifyRelacion =  await this.verifyTipoProyecto();
     (dataVerifyRelacion.length > 0 ) ? confirmDelete = false : "";
    //
     //##############  verificacion1 si existe datos relacionado ########################
     dataVerifyRelacion =  await this.verifyViabilidadTecnica();
     (dataVerifyRelacion.length > 0 ) ? confirmDelete = false : "";
    //
     //##############  verificacion1 si existe datos relacionado ########################
     dataVerifyRelacion =  await this.verifyHito();
     (dataVerifyRelacion.length > 0 ) ? confirmDelete = false : "";
    //
    //##############  verificacion1 si existe datos relacionado ########################
     dataVerifyRelacion =  await this.verifyAmbiente();
     (dataVerifyRelacion.length > 0 ) ? confirmDelete = false : "";
    //
     //##############  verificacion1 si existe datos relacionado ########################
     dataVerifyRelacion =  await this.verifyMejoras();
     (dataVerifyRelacion.length > 0 ) ? confirmDelete = false : "";
    //
  //##############  verificacion1 si existe datos relacionado ########################
     dataVerifyRelacion =  await this.verifyProceTipoCliente();
     (dataVerifyRelacion.length > 0 ) ? confirmDelete = false : "";
    //
     //##############  verificacion1 si existe datos relacionado ########################
     dataVerifyRelacion =  await this.verifyCaracteristicasDesempenio();
     (dataVerifyRelacion.length > 0 ) ? confirmDelete = false : "";
    //
   //##############  verificacion1 si existe datos relacionado ########################
     dataVerifyRelacion =  await this.verifyDesempenio();
     (dataVerifyRelacion.length > 0 ) ? confirmDelete = false : "";
    //
       //##############  verificacion1 si existe datos relacionado ########################
     dataVerifyRelacion =  await this.verifyImportanciaDesempenio();
     (dataVerifyRelacion.length > 0 ) ? confirmDelete = false : "";
    //
     //##############  verificacion1 si existe datos relacionado ########################
     dataVerifyRelacion =  await this.verifyComportamientoIndicador();
     (dataVerifyRelacion.length > 0 ) ? confirmDelete = false : "";
    //
     //##############  verificacion1 si existe datos relacionado ########################
     dataVerifyRelacion =  await this.verifyFrecuenciaIndicador();
     (dataVerifyRelacion.length > 0 ) ? confirmDelete = false : "";
    //
     //##############  verificacion1 si existe datos relacionado ########################
     dataVerifyRelacion =  await this.verifyExpresionIndicador();
     (dataVerifyRelacion.length > 0 ) ? confirmDelete = false : "";
    //
    
    if (confirmDelete)
    {
      if(this.getParent(this.idDeleteRegister))
      {

      this.configPeriodosService.delete(
        {
          "idSprComun": this.idDeleteRegister,
          "usuario": this.currentUser.idSprUsuario,
          "delLog": "S",
          "ip": this.ipAddress
        }
      )
        .subscribe(resp => {
          this.initApp();
          this.modal.close()
          this.alert.deleteOk();
        }, (err) => {
          this.alert.deleteError();
        });
    }
  }
  else{
    this.alert.EliminarRegistro()
  }
}


  openModal() {

    this.onResetForm();
    this.modal.open(this.nameModal);
    if(this.selectedOptionRecursivo==0 || this.selectedOptionRecursivo==null){
      this.nombrePadre= null
   


  }
  this.formComun.patchValue({
    spr_idSprComun : this.selectedOptionRecursivo,
    nombrePadre          : this.nombrePadre,
  });
}

  // Resetear el formulario
  //################################################
  onResetForm() {
    this.formComun.reset();
    this.submitted = false;
  }
}
